import { render, staticRenderFns } from "./CustomerOrdersForm.vue?vue&type=template&id=d218246c&scoped=true&"
import script from "./CustomerOrdersForm.vue?vue&type=script&lang=js&"
export * from "./CustomerOrdersForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOrdersForm.vue?vue&type=style&index=0&id=d218246c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d218246c",
  null
  
)

export default component.exports